export default "__VITE_ASSET__CqFh7web__"